import { ProductV2 } from "./productv2.model";
import { AtomicProductV2 } from "./atomic-productv2.model";

export class PackProductV2 extends ProductV2 {

    device: AtomicProductV2;
    consumable: AtomicProductV2;
}